import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * Import assets
 */
import QuestionMark from '../../assets/img/icons/questionmark.svg';
import connect from "react-redux/es/connect/connect";
import actions from "../../actions";
import {getContent} from "../../helpers/popupHelper";

const { updatePopups } = actions.popup;

class QuestionButton extends Component {
  static propTypes = {
    elementFocus: PropTypes.string,
    popupId: PropTypes.string,
  };
  static defaultProps = {
    popupId: '',
    elementFocus: '',
  };

  constructor(props) {
    super(props);
    this.state = { showPopUp: false };
  }

  render() {
    const { props } = this;
    const { dispatch } = props;
    let { wrap } = props;
    if(!wrap) wrap = "div";
    if(getContent(props.popupId, props.gameState.language) === "") {
      return (
        this.props.children
      );
    }
    return (
      <div onClick={(e) => {
        e.preventDefault();
        dispatch(updatePopups({ popupId: props.popupId, closeable: true, tutorial: false }))
      }}>
        {this.props.children}
        <div className="question-mark">
          <img alt="questionMark" src={QuestionMark}/>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(QuestionButton);



// WEBPACK FOOTER //
// ./src/components/elements/QuestionButton.js